{
  "nl": {
    "form": {
      "actions": {
        "cancel": "Annuleren",
        "clear": "Wissen",
        "closeFullPage": "Volledige pagina sluiten",
        "copyText": "Klik om tekst te kopiëren",
        "next": "Volgende",
        "openFullPage": "Open in volledige pagina",
        "save": "Opslaan",
        "saveChanges": "Sla veranderingen op",
        "search": "Zoeken...",
        "send": "Verzenden",
        "send_and_create_another": "Verzenden en nog één maken",
        "submit": "Opslaan",
        "submit_and_create_another": "Opslaan en nog één maken"
      },
      "back": "Vorige stap",
      "labels": {
        "columns": "Kolommen",
        "no_results": "Geen resultaten"
      },
      "notifications": {
        "textHasBeenCopied": "   Tekst is gekopieerd"
      },
      "password": "Wachtwoord",
      "shortcuts": {
        "save_mac": "⌘ + Enter om op te slaan",
        "save_windows": "Ctrl + Enter om op te slaan",
        "send_mac": "⌘ + Enter om te verzenden",
        "send_windows": "Ctrl + Enter om te verzenden"
      },
      "steps": "Stap {count} van {total}",
      "writeEmployeeNameReject": "Schrijf <i><b>{employeeName}</b></i> neer om het verwijderen te bevestigen."
    }
  }
}